var _circle, _path, _path2, _path3, _circle2, _path4, _circle3, _path5, _circle4, _path6, _circle5, _path7, _circle6, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGruppe = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EDF4F3",
  d: "M14.49 21.011h36.226v22.34H14.49z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.302 21.011c-1 0-1.812.81-1.812 1.811V38.52h32c1 0 1.812-.81 1.812-1.81V21.01h-32Z",
  fill: "#EDF4F3"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.717 41.54v-1.208H14.49v1.207c0 1 .811 1.812 1.812 1.812h32.603c1 0 1.812-.811 1.812-1.812Zm-15.095 1.81.604 2.416H38.038c.666 0 1.207.54 1.207 1.207v1.812H25.962v-1.812c0-.667.54-1.207 1.207-1.207h1.812l.202-.81.402-1.605h6.037Z",
  fill: "#405B73"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.603,
  cy: 25.237,
  r: 1.811,
  fill: "#FBE1CA"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.585 30.671v-.604a3.019 3.019 0 1 1 6.038 0v.604",
  fill: "#405B73"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.603,
  cy: 34.898,
  r: 1.811,
  fill: "#FBE1CA"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.585 40.332v-.604a3.019 3.019 0 1 1 6.038 0v.604",
  fill: "#405B73"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 44.678,
  cy: 34.898,
  r: 1.811,
  fill: "#FBE1CA"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.66 40.332v-.604a3.019 3.019 0 1 1 6.038 0v.604",
  fill: "#405B73"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.528,
  cy: 34.898,
  r: 1.811,
  fill: "#FBE1CA"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.509 40.332v-.604a3.019 3.019 0 1 1 6.038 0v.604",
  fill: "#405B73"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.528,
  cy: 25.237,
  r: 1.811,
  fill: "#FBE1CA"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.509 30.671v-.604a3.019 3.019 0 1 1 6.038 0v.604",
  fill: "#405B73"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.717 30.068H39.245v-6.021h-1.208v6.02H27.17v-9.056h-1.208v9.057H14.49v1.207h11.472v9.057h1.207v-9.057h10.868v9.057h1.208v-9.057h11.472v-1.207Z",
  fill: "#E7E8E8"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M47.465 15.698h-8.348c-1.095 0-1.985.89-1.985 1.985v5.807c0 1.095.925 2.02 2.02 2.02l4.157.002 1.404 2.62a.464.464 0 0 0 .462.242.464.464 0 0 0 .397-.337l.709-2.525h1.184c1.095 0 1.986-.89 1.986-1.986v-5.843c0-1.094-.89-1.985-1.986-1.985Z",
  fill: "#F4CC54"
})));
export default SvgIconGruppe;